import { Container } from "@mui/material";
import CookiePolicyNl from "@client/mdxFiles/cookiePolicyNl.mdx";
import CookiePolicyFr from "@client/mdxFiles/cookiePolicyFr.mdx";
import { sizes } from "@styles/Theme";
import { useRouter } from "next/router";

export default function Page() {
  const locale = useRouter().locale;
  return (
    <>
      <Container sx={{ mt: sizes.navBarHeight }}>
        {locale == "nl" && <CookiePolicyNl />}
        {locale == "fr" && <CookiePolicyFr />}
      </Container>
    </>
  );
}
